
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Client, IRequestResetPasswordModel, RequestResetPasswordModel } from '@/services/api.service';
  import * as ValidateUtils from '@/utilities/validate.utils';

  @Component({})
  export default class ResetPassword extends Vue {
    public requestSent: boolean = false;
    public emailAddress: string = '';
    public disableResetButton: boolean = true;

    public requestResetPassword() {
      // Call the api with the email address
      // @ts-ignore
      this.$Progress.start();

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      const model = new RequestResetPasswordModel();
      model.emailAddress = this.emailAddress;
      clientService
        .requestResetPassword( model)
        .then(data => {
          console.log('Resetting password completed ok');
          // @ts-ignore
          this.$Progress.finish();
          // @ts-ignore
          this.$awn.success('Reset password requested');
          this.requestSent = true;
        })
        .catch(error => {
          console.log('Resetting password failed');
          console.log(error);
          // @ts-ignore
          this.$Progress.finish();
          // @ts-ignore
          this.$awn.alert('There was an error requesting the password reset');
        });
    }

    @Watch('emailAddress')
    private onPropertyChanged(value: string, oldValue: string) {
      // Do stuff with the watcher here.
      if (ValidateUtils.validateEmail(value)) {
        this.disableResetButton = false;
      } else {
        this.disableResetButton = true;
      }
    }
  }
